import PropTypes from 'prop-types'

import TextInput from 'components/TextInput'

import FormSection from 'pages/shared/FormSection'

import { scrubText } from 'helpers/inputCleaners'

const propTypes = {
  onChangeCallback: PropTypes.func.isRequired,
  caption: PropTypes.string,
  link: PropTypes.string,
  errors: PropTypes.shape(PropTypes.shape)
}

const defaultProps = {
  caption: '',
  link: '',
  errors: {}
}

const ActionButtonFields = ({ caption, link, onChangeCallback, errors }) => {
  const handleLinkChange = event => {
    let url = scrubText(event.target.value, true)
    if (url && !url.toLowerCase().startsWith('http')) {
      url = `https://${url}`
    }
    onChangeCallback({ actionButtonLink: url })
  };

  return (
    <FormSection title="Action Button">
      <TextInput
        label="Caption"
        onChange={event => onChangeCallback({ actionButtonCaption: scrubText(event.target.value, true) })}
        value={caption || ''}
        errorMessage={errors.actionButtonCaption}
      />

      <TextInput
        label="Link"
        onChange={event => onChangeCallback({ actionButtonLink: scrubText(event.target.value, true) })}
        onBlur={handleLinkChange}
        value={link || ''}
        type="url"
      />
    </FormSection>
  )
}

ActionButtonFields.propTypes = propTypes
ActionButtonFields.defaultProps = defaultProps

export default ActionButtonFields
